module.exports = __webpack_public_path__ + "img/pig-image.c13ed749.png";